module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Treść lewej kolumny",
      "error": _vm.errors[_vm.addLanguageSuffix('title')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('title')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('title'), $$v)
      },
      expression: "form[addLanguageSuffix('title')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Treść środkowej kolumny",
      "error": _vm.errors[_vm.addLanguageSuffix('content')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('content')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('content'), $$v)
      },
      expression: "form[addLanguageSuffix('content')]"
    }
  })], 1), _vm._v(" "), _c('edition-input', {
    attrs: {
      "errors": _vm.errors.edition,
      "clearable": true,
      "required": true
    },
    model: {
      value: (_vm.form.edition),
      callback: function($$v) {
        _vm.$set(_vm.form, "edition", $$v)
      },
      expression: "form.edition"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Rodzaj wydarzenia",
      "required": "",
      "error": _vm.errors['event_type']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Wybierz typ wydarzenia"
    },
    model: {
      value: (_vm.form.event_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "event_type", $$v)
      },
      expression: "form.event_type"
    }
  }, _vm._l((_vm.types), function(type) {
    return _c('el-option', {
      key: type,
      attrs: {
        "label": _vm.translateType(type),
        "value": type
      }
    })
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5df98756"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/RepertoireWidget.vue
// module id = 763
// module chunks = 0